'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _extend = require('lodash/object/extend');

var _extend2 = _interopRequireDefault(_extend);

var _loader = require('signer/components/common/loader');

var _loader2 = _interopRequireDefault(_loader);

var _actionBar = require('./action-bar');

var _actionBar2 = _interopRequireDefault(_actionBar);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _signature = require('hellosign/models/signature');

var _signature2 = _interopRequireDefault(_signature);

var _setTimeout = require('common/utils/set-timeout');

var _setTimeout2 = _interopRequireDefault(_setTimeout);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _signatureEditArea = require('./signature-edit-area');

var _signatureEditArea2 = _interopRequireDefault(_signatureEditArea);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx(_loader2['default'], {
    className: 'm-sign-modal--tabs--email--loader'
});

var _ref2 = _jsx(_reactIntl.FormattedMessage, {
    id: 'signModal.email.instructions.header'
});

var _ref3 = _jsx(_reactIntl.FormattedMessage, {
    id: 'signModal.email.instructions.step_2'
});

var _ref4 = _jsx(_reactIntl.FormattedMessage, {
    id: 'signModal.email.instructions.subject'
});

var _ref5 = _jsx(_reactIntl.FormattedMessage, {
    id: 'signModal.email.instructions.step_3'
});

var EmailTab = _react2['default'].createClass({
    displayName: 'EmailTab',


    retries: 0,
    retryLimit: _constants2['default'].EMAIL_STATUS_MAX_RETRIES,
    retryPeriod: _constants2['default'].EMAIL_STATUS_RETRY_PERIOD,

    propTypes: {
        'app': _react2['default'].PropTypes.object.isRequired,
        'type': _react2['default'].PropTypes.string.isRequired,
        'onBeforeInsert': _react2['default'].PropTypes.func.isRequired,
        'onInsert': _react2['default'].PropTypes.func.isRequired,
        'onClose': _react2['default'].PropTypes.func.isRequired,
        'onError': _react2['default'].PropTypes.func.isRequired,
        'isSelected': _react2['default'].PropTypes.bool.isRequired,
        'deviceOrientation': _react2['default'].PropTypes.string.isRequired,
        'screenSize': _react2['default'].PropTypes.string.isRequired,
        'locales': _react2['default'].PropTypes.array.isRequired,
        'messages': _react2['default'].PropTypes.object.isRequired,
        'isMobile': _react2['default'].PropTypes.bool.isRequired,
        'emailGuid': _react2['default'].PropTypes.string,
        'emailUploadAddress': _react2['default'].PropTypes.string,
        'buttonText': _react2['default'].PropTypes.string // Text to be displayed on the CTA
    },

    //  ----  LIFECYCLE  ----------------------------------

    getInitialState: function getInitialState() {

        var guid = this.props.emailGuid;
        if (!guid) {
            guid = this.props.type === _constants2['default'].TYPE_SIGNATURE ? this.props.app.emailGuids.signature_email_guid : this.props.app.emailGuids.initials_email_guid;
        }

        return {
            'isSignature': this.props.type === _constants2['default'].TYPE_SIGNATURE,
            'isInitials': this.props.type === _constants2['default'].TYPE_INITIALS,
            'showSpinner': false,
            'showEditArea': false,
            'showError': false,
            'signature': null,
            'emailGuid': guid,
            'emailUploadAddress': this.props.emailUploadAddress || this.props.app.emailUploadAddress
        };
    },

    //  ----  BEHAVIOR  -----------------------------------

    insertSignature: function insertSignature(insertEverywhere) {

        var self = this;
        var emailEditArea = this.refs.emailEditArea;
        var params = {};
        var isCropped = emailEditArea.state.isCropped;

        if (isCropped) {
            params = {
                'is_cropped': isCropped,
                'x': emailEditArea.state.cropX,
                'y': emailEditArea.state.cropY,
                'width': emailEditArea.state.cropWidth,
                'height': emailEditArea.state.cropHeight
            };
        }

        params.threshold = emailEditArea.state.contrastValue;
        params.degrees = emailEditArea.state.degreesValue;
        params.guid = this.state.signature.guid;

        var signatureData = (0, _extend2['default'])((0, _extend2['default'])({}, this.state.signature.data), params);

        if (!this.props.onBeforeInsert || this.props.onBeforeInsert(signatureData) !== false) {

            // Notifies creation has started
            this.props.onInsert(null, null, true);

            // Create the signature and inserts it
            this.createSignature(params).then(function (signature) {
                self.props.onInsert(signature, insertEverywhere);
            })['catch'](function (error) {
                self.props.onError(error);
            });
        }
    },

    createSignature: function createSignature(signatureData) {
        // Set parameters from edit pane
        this.state.signature.setEditParams(signatureData);
        // Then get list of signatures, and use the edit endpoint to add
        return this.props.app.user.getSignatures(this.props.type).addFromEdit(this.state.signature);
    },

    //  ----  HELPERS  ------------------------------------

    startSignatureFlow: function startSignatureFlow() {

        this.showSpinner();

        var sig = _signature2['default'].create({
            'notifier': this.props.app.notifier,
            'emailGuid': this.state.emailGuid,
            'type': this.props.type,
            'createType': _constants2['default'].SIGNATURE_TYPE_EMAIL
        });

        var callback = function (err, data) {

            if (err) {
                this.props.onError(err);
            }

            if (data.status) {

                if (data.status == 'pending') {

                    // Repeat the cycle as retries permit
                    this.retries++;
                    if (this.retries < this.retryLimit) {
                        (0, _setTimeout2['default'])(function () {
                            sig.checkEmailSignatureStatus().then(callback.bind(this, void 0))['catch'](callback);
                        }, this.retryPeriod);
                    } else {
                        this.hideSpinner();
                        this.props.onError(new Error('Retries timed out'));
                    }
                }

                if (data.status == 'ok') {

                    // End and assign id
                    sig.guid = data.signature_guid;
                    sig.width = data.width;
                    sig.height = data.height;
                    this.state.signature = sig;

                    // Show edit pane
                    this.hideSpinner();
                    this.showEditArea();

                    // Refresh Guids
                    this.refreshGuids(data);
                }

                if (data.status == 'error') {
                    this.hideSpinner();
                    this.refreshGuids(data);
                    this.props.onError(new Error('Server Error'));
                }
            }
        }.bind(this);

        sig.checkEmailSignatureStatus().then(callback.bind(this, void 0));
    },

    refreshGuids: function refreshGuids(data) {
        if (data.hasOwnProperty('new_email_guid')) {

            var newGuid = data.new_email_guid;

            if (typeof this.props.app.emailGuids === 'undefined') {
                this.props.app.emailGuids = [];
            }
            if (this.props.type === _constants2['default'].TYPE_SIGNATURE) {
                this.props.app.emailGuids.signature_email_guid = newGuid;
            } else {
                this.props.app.emailGuids.initials_email_guid = newGuid;
            }
        }
    },

    showEditArea: function showEditArea() {
        this.setState({
            'showEditArea': true
        });
    },

    hideEditArea: function hideEditArea() {
        this.setState({
            'showEditArea': false
        });
    },

    showSpinner: function showSpinner() {
        this.setState({
            'showSpinner': true
        });
    },

    hideSpinner: function hideSpinner() {
        this.setState({
            'showSpinner': false
        });
    },

    showError: function showError() {
        this.setState({
            'showError': true
        });
    },

    shouldDisableButtons: function shouldDisableButtons() {
        return !!this.state.showSpinner;
    },

    onContinue: function onContinue() {
        if (this.state.showError) {
            this.resetTab();
            return;
        }

        this.startSignatureFlow();
    },

    resetRetries: function resetRetries() {
        this.retries = 0;
    },

    resetTab: function resetTab() {
        this.setState({
            'showError': false,
            'showEditArea': false,
            'showSpinner': false
        });
        this.resetRetries();
    },

    //  ----  RENDERING  ----------------------------------

    render: function render() {

        var changeLink;
        var spinner;

        var emailAddress = this.state.emailUploadAddress;
        var emailGuid = this.state.emailGuid;

        var inputClasses = {
            'm-sign-modal--tabs--email--input': true
        };
        var classes = {
            'm-sign-modal--tabs--email': true
        };
        var containerClasses = {
            'm-sign-modal--tabs--tab': true,
            'is-selected': this.props.isSelected
        };
        var errorClasses = {
            'm-sign-modal--tabs--email--error': true
        };

        // Switch Display

        var emailInstructionsStyle = { display: 'none' };
        var editStyle = { display: 'none' };
        var spinnerStyle = { display: 'none' };

        if (this.state.showEditArea) {
            editStyle.display = 'inherit';
        } else if (this.state.showSpinner) {
            spinnerStyle.display = 'inherit';
        } else {
            emailInstructionsStyle.display = 'inherit';
        }

        containerClasses[_constants2['default'].TAB_EMAIL] = true;

        if (this.state.showSpinner) {
            spinner = _ref;
        }

        var steps = _jsx('div', {
            className: 'm-sign-modal--tabs--email--steps'
        }, void 0, _jsx('div', {
            className: 'm-sign-modal--tabs--email--steps--header'
        }, void 0, _ref2), _jsx('div', {
            className: 'm-sign-modal--tabs--email--steps--step'
        }, void 0, _jsx(_reactIntl.FormattedMessage, {
            id: 'signModal.email.instructions.step_1',
            values: { type: this.props.type }
        })), _jsx('div', {
            className: 'm-sign-modal--tabs--email--steps--step'
        }, void 0, _jsx('p', {
            style: { display: 'inline-block', width: 180, fontWeight: 'normal', lineHeight: '18px', fontSize: '14px' }
        }, void 0, _ref3), _jsx('strong', {}, void 0, emailAddress)), _jsx('div', {
            className: 'm-sign-modal--tabs--email--steps--subject'
        }, void 0, _ref4, _jsx('strong', {}, void 0, this.state.emailGuid)), _jsx('div', {
            className: 'm-sign-modal--tabs--email--steps--step'
        }, void 0, _ref5));

        return _jsx('div', {
            className: (0, _classnames2['default'])(containerClasses)
        }, void 0, _jsx('span', {
            className: 'm-sign-modal--tabs--tab-title'
        }, void 0, _jsx(_reactIntl.FormattedMessage, {
            id: 'signModal.email.title',
            values: { type: this.props.type }
        })), _jsx('div', {
            className: (0, _classnames2['default'])(classes)
        }, void 0, _jsx('div', {
            className: (0, _classnames2['default'])(inputClasses)
        }, void 0, _jsx('div', {
            className: 'm-sign-modal--tabs--content'
        }, void 0, _jsx('div', {
            className: 'm-sign-modal--tabs--email--part1',
            style: emailInstructionsStyle
        }, void 0, steps), _jsx('div', {
            style: spinnerStyle
        }, void 0, spinner), _jsx('div', {
            style: editStyle
        }, void 0, _react2['default'].createElement(_signatureEditArea2['default'], _extends({}, this.props, {
            signature: this.state.signature,
            ref: 'emailEditArea' })))))), _react2['default'].createElement(_actionBar2['default'], _extends({}, this.props, {
            type: this.props.type,
            isMobile: this.props.isMobile,
            locales: this.props.locales,
            messages: this.props.messages,
            onInsert: this.insertSignature,
            onClose: this.props.onClose,
            disableButtons: this.shouldDisableButtons(),
            continueInsteadOfInsert: !this.state.showEditArea,
            buttonText: this.props.buttonText,
            onContinue: this.onContinue })));
    }
});

module.exports = EmailTab;


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/components/common/signature-modal/email-tab.jsx
 ** module id = 681
 ** module chunks = 0
 **/